import styled from "styled-components";

const TitleText = styled.div`
  font-size: 26px;
`;

export const Title = () => {
  return <TitleText>AI 不動産査定</TitleText>;
};
